"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const l=require("@mui/material"),r=l.styled("span")`
  filter: ${({isVisible:e,size:t})=>e?"none":`blur(${t}px)`};
`;exports.StyledObfuscatedText=r;
